import { Button } from 'components/Button';
import { ButtonGroup } from 'components/ButtonGroup';
import { PageToolbar } from 'components/PageToolbar';
import { Menu } from 'components/Menu';
import { PageHeader } from 'components/PageHeader';
import { useScreenSize } from 'hooks/useScreenSize';
import { ScreenSize } from 'lib/constants';
import { pluralise, pluraliseS } from 'lib/pluralise';
import * as React from 'react';

type SortOptions = 'relevant:asc' | 'name:asc' | 'name:desc';

type Props = {
  openOrganisationFilter: () => void;
  // Options
  organisationOptions: { id: string; name: string }[];
  sortOptions: { id: SortOptions; name: string }[];
  // Values
  organisationIds: string[];
  sortId: SortOptions;
  searchText: string;
  selectedPropertyIds: string[];
  //
  onClose: () => void;
  onDownloadPress: () => void;
  onChangeSort: (value: SortOptions) => void;
  onSearch: (value: string) => void;
};

export const CloudAssetsHeader: React.FC<Props> = ({
  onClose,
  onDownloadPress,
  openOrganisationFilter,
  onChangeSort,
  onSearch,
  organisationOptions: organisations,
  organisationIds,
  sortOptions,
  sortId,
  selectedPropertyIds,
  searchText,
}) => {
  const screenSize = useScreenSize();
  const hasPropertiesSelected = !!selectedPropertyIds.length;

  const filteredOrganisations = organisations.filter((o) =>
    organisationIds.includes(o.id),
  );

  return (
    <>
      <PageHeader
        title={'Download Properties'}
        subtitle={
          selectedPropertyIds.length
            ? pluralise(
                selectedPropertyIds.length,
                '1 Property',
                '{x} Properties',
              )
            : undefined
        }
        onPressSaveButton={hasPropertiesSelected ? onDownloadPress : onClose}
        onPressCancelButton={onClose}
      />
      <PageToolbar
        searchPlaceholder="Search"
        onSearch={onSearch}
        searchValue={searchText}
        searchDisabled={hasPropertiesSelected}
        searchFieldAbove={screenSize === ScreenSize.small}
        searchOnSubmit
      >
        <ButtonGroup disabled={hasPropertiesSelected}>
          {organisations.length > 1 && (
            <Button
              text={
                filteredOrganisations.length === 0
                  ? 'All Orgs'
                  : filteredOrganisations.length === 1
                    ? organisations.find((o) => organisationIds.includes(o.id))
                        ?.name || 'Unkown Org'
                    : pluraliseS(filteredOrganisations.length, 'Organisation')
              }
              onPress={openOrganisationFilter}
              disabled={selectedPropertyIds.length !== 0}
              style={{ maxWidth: 150 }}
            />
          )}
          <Menu
            buttonConfig={{
              text: sortOptions.find((s) => s.id === sortId)?.name || 'Sort',
              disabled: hasPropertiesSelected,
            }}
            options={sortOptions.map((option) => ({
              text: option.name,
              onPress: () => onChangeSort(option.id),
            }))}
            width={120}
          />
        </ButtonGroup>
      </PageToolbar>
    </>
  );
};
